import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import BottomNav from './BottomNav';
import Sidebar from './Sidebar';
import NotificationDrawer from './NotificationDrawer';
import RealtimeInsightAlert from '../insights/RealtimeInsightAlert';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

export default function Layout() {
  const { t } = useTranslation();
  const [sidebarOpen,      setSidebarOpen]      = useState(window.innerWidth >= 1024);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [notifOpen,        setNotifOpen]        = useState(false);
  const isOnline = useOnlineStatus();

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024) setSidebarOpen(true);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div className="flex h-[100dvh] overflow-hidden bg-gray-50 dark:bg-gray-950">

      {/* Mobile sidebar backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/60 backdrop-blur-[2px] lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <Sidebar
        open={sidebarOpen}
        collapsed={sidebarCollapsed}
        onClose={() => setSidebarOpen(false)}
        onToggleCollapse={() => setSidebarCollapsed((v) => !v)}
        onNotifClick={() => setNotifOpen(true)}
      />

      <div className="flex flex-1 flex-col min-w-0 overflow-hidden">
        <Header
          onMenuClick={() => setSidebarOpen((v) => !v)}
          onNotifClick={() => setNotifOpen(true)}
        />
        {!isOnline && (
          <div className="bg-amber-500 text-white text-xs font-semibold text-center py-1.5 px-4 flex items-center justify-center gap-2 flex-shrink-0">
            <span>{t('layout.offlineBanner', "You're offline — changes cannot be saved until reconnected")}</span>
          </div>
        )}
        <main className="flex-1 overflow-y-auto [scrollbar-gutter:stable]">
          <div className="page-container">
            <Outlet />
          </div>
        </main>
      </div>

      <BottomNav />

      {/* Notification side drawer */}
      <NotificationDrawer open={notifOpen} onClose={() => setNotifOpen(false)} />

      {/* Real-time high severity insight alerts */}
      <RealtimeInsightAlert />
    </div>
  );
}
